export default __webpack_public_path__ + "static/media/cara.bc215511.webp";